import Musicboxd from "../../assets/musicboxd.png";

const Menu = [
	{
		id: 1,
		image: Musicboxd,
		title: "Musicboxd",
		category: ["Django", "NextJS"],
		url: "https://musicboxd.app",
		repositoryUrl: "https://github.com/jlemoureATSSU/Musicboxd-v2"
	}
];

export default Menu;
